import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  ExtendedBaseInterface,
  ISearchRequest,
  PayrollSubmissions,
  UpdateAgentPayrollStatus,
  User,
} from '../../store/Authentication/auth.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { GlobalComponent } from '../../global-component';

// Action
import {
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
  RegisterSuccess,
} from '../../store/Authentication/authentication.actions';
import { environment } from 'src/environments/environment';

const AUTH_API = environment.API_URL;

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user!: User;
  currentUserValue: any;

  private currentUserSubject: BehaviorSubject<User>;

  constructor(private http: HttpClient, private store: Store) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser')!)
    );
  }

  register(email: string, first_name: string, password: string) {
    return this.http
      .post(
        AUTH_API + 'signup',
        {
          email,
          first_name,
          password,
        },
        httpOptions
      )
      .pipe(
        map((response: any) => {
          const user = response;
          this.store.dispatch(RegisterSuccess({ user }));
          return user;
        }),
        catchError((error: any) => {
          const errorMessage = 'Login failed'; // Customize the error message as needed
          this.store.dispatch(loginFailure({ error: errorMessage }));
          return throwError(errorMessage);
        })
      );
  }

  login(email: string, password: string) {
    this.store.dispatch(login({ email, password }));

    return this.http
      .post(
        AUTH_API + 'auth/login',
        {
          email,
          password,
        },
        httpOptions
      )
      .pipe(
        map((response: any) => {
          const user = response;
          this.store.dispatch(loginSuccess());
          return user;
        }),
        catchError((error: any) => {
          const errorMessage = 'Login failed'; // Customize the error message as needed
          this.store.dispatch(loginFailure({ error: errorMessage }));
          return throwError(errorMessage);
        })
      );
  }

  logout(): Observable<void> {
    this.store.dispatch(logout());
    // Perform any additional logout logic, e.g., calling an API to invalidate the token

    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    this.currentUserSubject.next(null!);
    this.store.dispatch(logoutSuccess());

    // Return an Observable<void> indicating the successful logout
    return of(undefined).pipe(
      tap(() => {
        // Perform any additional logic after the logout is successful
      })
    );
  }

  resetPassword(email: string) {
    return this.http.post(AUTH_API + 'reset-password', { email }, httpOptions);
  }

  getAgentPayrollSubmissions(data: ISearchRequest) {
    return this.http.get<ExtendedBaseInterface>(
      `${AUTH_API}PayrollSubmissions/GetAllPayrollSubmissions?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&SortColumn=${data.SortColumn}&SortOrder=${data.SortOrder}&Search=${data.Search}`
    );
  }

  getAgentPayrollSubmissionDetails(id: number) {
    return this.http.get<PayrollSubmissions>(
      `${AUTH_API}PayrollSubmissions/GetPayrollSubmission?id=${id}`
    );
  }

  updateAgentPayrollSubmissionStatus(data: UpdateAgentPayrollStatus) {
    return this.http.post<ExtendedBaseInterface>(
      `${AUTH_API}PayrollSubmissions/UpdateStatus`,
      data
    );
  }
}
